import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-tiktok-batch-detail',
  templateUrl: './tiktok-batch-detail.component.html',
  styleUrls: ['./tiktok-batch-detail.component.css']
})
export class TikTokBatchDetailComponent implements OnInit {
  batch: any = null;
  loading = true;
  batchId: string = '';
  expandedItems: Set<string> = new Set();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit() {
    this.batchId = this.route.snapshot.paramMap.get('id') || '';
    if (this.batchId) {
      this.loadBatchDetail();
    }
  }

  loadBatchDetail() {
    this.loading = true;
    this.http.get<any>(`/api/TikTokAd/GetBatchDetail/${this.batchId}`).subscribe(
      response => {
        this.batch = response;
        this.loading = false;
      },
      error => {
        console.error('Error loading batch detail:', error);
        this.loading = false;
      }
    );
  }

  getStatusBadgeClass(displayStatus: string): string {
    if (displayStatus.includes('Success')) return 'success';
    if (displayStatus.includes('Retrying')) return 'warning';
    return 'danger';
  }

  toggleItemExpansion(itemId: string) {
    if (this.expandedItems.has(itemId)) {
      this.expandedItems.delete(itemId);
    } else {
      this.expandedItems.add(itemId);
    }
  }

  isItemExpanded(itemId: string): boolean {
    return this.expandedItems.has(itemId);
  }

  goBack() {
    this.router.navigate(['/tiktok-ad']);
  }

  refreshDetail() {
    this.loadBatchDetail();
  }
}
